import { ref } from 'vue'

// Importer din JSON-data for posts
import postsData from '@/data/blogPosts.json'

const posts = ref(postsData)

export function useBlog() {

    /**
     * Henter alle blogindlæg (sorteret efter ID, nyeste først)
     */
    const getAllPosts = () => {
        // Sorterer, så det nyeste indlæg (højeste ID) er først
        return posts.value.sort((a, b) => b.id - a.id);
    }

    /**
     * Henter et enkelt blogindlæg baseret på dets 'slug'
     * @param {string} slug
     */
    const getPostBySlug = (slug) => {
        return posts.value.find(p => p.slug === slug) || null;
    }

    return {
        getAllPosts,
        getPostBySlug
    }
}